import React, { Component, lazy } from "react";
import { connect } from "react-redux";

// import { setInitialFilterRefineValues, setInitialConversationFilter } from "../../../actions/dashboardAction";

const LoadableDashboardPage = lazy(() => import("../Dashboard/DashboardPage"));

class DashboardContentPage extends Component {
    state = {};

    componentDidMount() {
        // let filterRefineFilter = {
        //     sentiment: ["all"],
        //     sentimentType: "all",
        //     media: "all",
        //     postType: "all",
        //     sampling: "100",
        //     channel: "all",
        //     exclusion: "yes",
        // };
        // this.props.setInitialFilterRefineValues(filterRefineFilter);
        // const collectionDefaultFilters = {
        //     countries: ["selectAll"],
        //     platforms: ["selectAll"],
        //     languages: ["selectAll"],
        //     duration: "7",
        //     startDateTime: "",
        //     endDateTime: "",
        //     publications: [],
        //     entityType: "all",
        //     entitySubType: "all",
        //     filterKeyword: "",
        //     rollingDate: false,
        // };
        // this.props.setInitialConversationFilter(collectionDefaultFilters);
    }

    render() {
        return <LoadableDashboardPage {...this.props} dashboardPageType="dashboard" />;
    }
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(null, mapDispatchToProps)(DashboardContentPage);
